import React from 'react'
import Layout from '../../../layout/Layout'

export default function NotAuthorized() {
  return (
    <h1 className='text-center'>You are not authorized to view this page.</h1>
  )
}
